import { defineStore } from 'pinia'
import { ref } from 'vue'
import { Keyboard } from '@capacitor/keyboard'

export const useKeyboardStore = defineStore('keyboard', () => {
  const isTyping = ref(false)

  Keyboard.addListener('keyboardWillShow', (info) => {
    console.log('keyboard will show with height:', info.keyboardHeight)
  })

  Keyboard.addListener('keyboardDidShow', (info) => {
    isTyping.value = true
    console.log('keyboard did show with height:', info.keyboardHeight)
  })

  Keyboard.addListener('keyboardWillHide', () => {
    isTyping.value = false
    console.log('keyboard will hide')
  })

  Keyboard.addListener('keyboardDidHide', () => {
    console.log('keyboard did hide')
  })

  async function hideKeyboard() {
    console.log('hideKeyboard')
    try {
      await Keyboard.hide()
    }
    catch (error) {
      console.error(error)
    }
  }

  async function showKeyboard() {
    console.log('showKeyboard')
    try {
      await Keyboard.show()
    }
    catch (error) {
      console.error(error)
    }
  }

  return {
    isTyping,
    hideKeyboard,
    showKeyboard,
  }
})
